import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import AllgemeineAngaben from "../components/Gutachten/AllgemeineAngaben";
import Lage from "../components/Gutachten/Lage";
import Grundstueck from "../components/Gutachten/Grundstueck";
import Gebaeude from "../components/Gutachten/Gebaeude";
import Anlagen from "../components/Gutachten/Anlagen";
import Wertermittlung from "../components/Gutachten/Wertermittlung";
import Vorschau from "../components/Gutachten/Vorschau";
import DokumenteLinks from "../components/Gutachten/DokumenteLinks";
import { useSwitch } from './SwitchContext';
import { apiGet, parseJsonResponse } from "../api/apiClient";
import useScreenSize from "../hooks/useScreenSize";
const gutachtenTabs = ["allgemeine-angaben", "lage", "grundstueck", "gebaeude", "wertermittlung", "anlagen", "dokumente-links", "vorschau"];



const steps = [
  "Allgemeine Angaben",
  "Lage",
  "Grundstück",
  "Gebäude & Außenanlagen",
  "Wertermittlung",
  "Anlagen",
  "Übersicht \n Dokumente & Links",
  "Vorschau",
];

const tabComponentBySlug = {
  "allgemeine-angaben": AllgemeineAngaben,
  "lage": Lage,
  "grundstueck": Grundstueck,
  "gebaeude": Gebaeude,
  "wertermittlung": Wertermittlung,
  "anlagen": Anlagen,
  "dokumente-links": DokumenteLinks,
  "vorschau": Vorschau,
};

const Gutachten = () => {
  const { auftragID, gutachtenID, tab } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeStep, setActiveStep] = useState(0);
  const { isSwitchOn } = useSwitch();
  const { isDesktopView } = useScreenSize(768);
  const [dataContent, setDataContent] = useState(null);

  const fetchGutachtenInfos = async () => {
    try {
      const response = await apiGet(`/helper/acl/gutachten/${gutachtenID}?populate[0]=AllgAng.AllgAng_Detail`);
      const dataContainer = await parseJsonResponse(response);
      setDataContent(dataContainer.AllgAng.AllgAng_Detail);
    } catch (error) {
      console.error("Error fetching Gutachten infos:", error);
    }
  };

  useEffect(() => {
    if (!tab || !gutachtenTabs.includes(tab)) {
      const defaultUrl = `/gutachten/${auftragID}/${gutachtenID}/${gutachtenTabs[0]}`;
      navigate(defaultUrl, { replace: true });
      setActiveStep(0);
      return;
    }
    setActiveStep(gutachtenTabs.indexOf(tab));
  }, [auftragID, gutachtenID, navigate, tab]);

  useEffect(() => {
    fetchGutachtenInfos().then();
  }, [gutachtenID]);

  const handleStepChange = (step) => {
    setActiveStep(step);
    const newUrl = `/gutachten/${auftragID}/${gutachtenID}/${gutachtenTabs[step]}`;
    navigate(newUrl);
  };

  const ActiveComponent = tabComponentBySlug[gutachtenTabs[activeStep]] || AllgemeineAngaben;

  return (
    <>
      <>
        {dataContent && (
            isDesktopView ? (
            <div
                className={`p-4 xl:ml-0  ml-[15px] mr-[15px] ${isSwitchOn ? 'bg-black' : 'bg-white'} ${isSwitchOn ? 'borderRadiuClass1' : ''} rounded-tr-20 mb-4 md:mb-[20px] borderRadiuClass max-w-[100%] md:pl-2`}>
              <div className={`flex flex-row`}>
                <div
                    className={`basis-1/2 generalText ml-[6px] text-13 mb-4 md:text-16 ${isSwitchOn ? 'text-white' : 'text-black'}`}>
                  <Link to="/">Startseite</Link>/<Link
                    to={`/auftrag/${location.pathname.split("/")[2]}`}>Auftrag</Link>/ <span
                    className="text-19 font-bold"> <Link
                    to={`/gutachten/${location.pathname.split("/")[2]}/${location.pathname.split("/")[3]}`}>Gutachten</Link></span>
                </div>
                <div
                    className={`basis-1/2 text-right generalText ml-[6px] mr-[6px] text-13 mb-4 md:text-16 ${isSwitchOn ? 'text-white' : 'text-black'}`}>
                  {dataContent.Strasse} {dataContent.NrZusatz}
                  {dataContent.Ort && (dataContent.Strasse || dataContent.NrZusatz) && ", "}
                  {dataContent.Ort}
                </div>
              </div>
              <Stepper activeStep={activeStep} alternativeLabel className={`basis-full`}>
                {steps.map((label, index) => (
                    <Step key={label} onClick={() => handleStepChange(index)}>
                      <StepLabel className={"cursor-pointer"}>{label}</StepLabel>
                    </Step>
                ))}
              </Stepper>
            </div>
        ) : (
            <div className="flex flex-wrap">
              {steps.map((label, index) => (
                  <div
                      key={label}
                      onClick={() => handleStepChange(index)}
                      className={`flex items-center justify-center cursor-pointer p-2 m-2 text-white ${activeStep === index ? 'bg-red-500' : 'bg-gray-500'
                      } rounded`}
                  >
                  <div>{label}</div>
              </div>
            ))}
          </div>
        )
        )}
      </>
      <ActiveComponent />
    </>

  );
};


export default Gutachten;